// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/wespeakgerman.jpeg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".main-banner[data-v-1d7be79f]{background-size:cover;background-position:50%;--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");height:60vh}[data-v-1d7be79f] a{text-decoration:underline;--text-opacity:1;color:#ff7913;color:rgba(255,121,19,var(--text-opacity));cursor:pointer}", ""]);
// Exports
module.exports = exports;
